<template>
  <section>
    <div class="container wfs--main">
      <div class="row">
        <div class="col-md-12 bread">
          <ol class="bread-crumb breadcrumb-fill0">
            <li>
              <router-link to="/home">home</router-link>
            </li>
            <li>
              <a href="javascript:void(0);" class="bread-text">CIDADÃO REGISTRO</a>
            </li>
          </ol>
        </div>
        
        <reload  v-if="reload_hab"></reload>

        <card class="col-md-12">
          <h4 slot="header" class="card-title">Registrar</h4>
          <form>
            <div class="row">
              <div class="col-md-12" v-if="msgAlterada" style="padding-right: 13px;">
                <div
                  class="card"
                  style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;"
                  v-if="msg==1"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">{{msgAlterada}}</div>
                    </div>
                  </div>
                </div>
                <div
                  class="card"
                  style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 20px !important;"
                  v-if="msg==0"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">{{msgAlterada}}</div>
                    </div>
                  </div>
                </div>
                <div
                  class="card"
                  style="background-color: rgb(191 187 54) !important;color: #fff !important;margin-bottom: 20px !important;"
                  v-if="msg==2"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">{{msgAlterada}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" id="topo">
              <div class="col-md-12">
                <label>Nome</label>
                <input
                  id="nome"
                  type="text"
                  placeholder="Nome"
                  maxlength="250"
                  v-model="cidadao.nome"
                  class="form-control"
                  :style="styleNome"
                />
                <label
                  class="control-label"
                  v-if="styleNome!=''"
                  style="color:rgb(243 0 0);font-size: 12px;"
                >*Obrigatorio</label>
              </div>
            </div>  

            <div class="row">
              <div class="col-md-6">
                <label>Email</label>
                <input
                  type="email"
                  placeholder="Email"
                  maxlength="250"
                  v-on:blur="validacaoEmail(cidadao.email)"
                  v-model="cidadao.email"
                  class="form-control"
                  :style="styleEmail"
                />
                <div v-if="emailverify==0">
                  <label
                    class="control-label"
                    v-if="styleEmail!=''"
                    style="color:rgb(243 0 0);font-size: 12px;"
                  >*Obrigatorio</label>
                </div>
                <label
                  class="control-label"
                  v-if="emailverify==1"
                  style="color:rgb(54 154 104);font-size: 12px;"
                >Email Valido!</label>
              </div>

              <div class="col-md-6">
                <label>Verificar Email</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend" v-if="EmailVerify==1">
                    <span class="input-group-text-green" id="basic-addon1"><i class="fa fa-check" aria-hidden="true"></i></span>
                  </div>
                  <input
                    type="email"
                    placeholder="Email"
                    maxlength="250"
                    v-on:blur="validacaoEmailVerify(cidadao.email,cidadao.emailVerificar)"
                    v-model="cidadao.emailVerificar"
                    class="form-control"
                    :style="styleEmailVerify"
                  />
                </div>  
              </div>
            </div>

            <div class="row">
              <div  class="col-md-12" v-if="cidadao.emailVerificar != cidadao.email && cidadao.emailVerificar!=null && cidadao.email!=null && cidadao.email!='' && cidadao.emailVerificar!='' " >
                  <div
                    class="card"
                    style="background-color: rgb(170, 72, 50) !important;color: #fff !important;margin-bottom: 20px !important;"
                  >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        Emails não correspondem! 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <label>Senha</label>
                <input
                  type="password"
                  placeholder="Senha"
                  maxlength="250"
                  v-on:blur="validacaoSenha(cidadao.senha)"
                  v-model="cidadao.senha"
                  class="form-control"
                  :style="styleSenha"
                />
                <div v-if="senhaverify==0">
                  <label
                    class="control-label"
                    v-if="styleSenha!=''"
                    style="color:rgb(243 0 0);font-size: 12px;"
                  >*Obrigatorio</label>
                </div>
                <label
                  class="control-label"
                  v-if="senhaverify==1"
                  style="color:rgb(183 179 55);font-size: 12px;"
                >
                  <b v-if="senhaverify==1" >* minimo 4 caracteres</b>
                  <b style="color:#3fa247" v-else>* minimo 4 caracteres</b>
                  <br />* minimo 1 letra
                  <br />* minimo 1 numero
                  <!--<br />* minimo 1 caractere especial ex: &!#$-->
                </label>
              </div>

              <div class="col-md-6">
                <label>Verificar Senha</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend" v-if="SenhaVerify==1">
                    <span class="input-group-text-green" id="basic-addon1"><i class="fa fa-check" aria-hidden="true"></i></span>
                  </div>
                  <input
                    type="password"
                    placeholder="Senha"
                    maxlength="250"
                    v-on:blur="validacaoSenhaVerify(cidadao.senha,cidadao.senhaVerificar)"
                    v-model="cidadao.senhaVerificar"
                    class="form-control"
                    :style="styleSenhaVerify"
                  />
                </div>
              </div>

            </div> 

            <div class="row">
              <div  class="col-md-12" v-if="cidadao.senhaVerificar != cidadao.senha && cidadao.senhaVerificar!=null && cidadao.senha!=null && cidadao.senha!='' && cidadao.senhaVerificar!='' " >
                  <div
                    class="card"
                    style="background-color: rgb(170, 72, 50) !important;color: #fff !important;margin-bottom: 20px !important;"
                  >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        Senhas não correspondem! 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">  
              <div class="col-md-6">
                <div class="form-group">
                  <label for="sel1">Tipo:</label>
                  <select class="form-control" id="tipo" name="tipo" v-model="cidadao.tipo">
                    <option>Física</option>
                    <option>Jurídica</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row" v-if="cidadao.tipo =='Jurídica'">
              <div class="col-md-12">
                <label>CNPJ</label>
                <the-mask
                  class="form-control"
                  placeholder="CNPJ"
                  v-model="cidadao.cnpj"
                  :mask="['##.###.###/####-##']"
                  :style="styleCnpj"
                />
                <label
                  class="control-label"
                  v-if="styleCnpj!=''"
                  style="color:rgb(243 0 0);font-size: 12px;"
                >*Obrigatorio</label>
              </div>
            </div>

            <div class="row" v-if="cidadao.tipo =='Física'">
              <div class="col-md-12">
                <label>CPF</label>
                <the-mask
                  class="form-control"
                  placeholder="CPF"
                  v-model="cidadao.cpf"
                  :mask="['###.###.###-##']"
                  :style="styleCpf"
                />
                <label
                  class="control-label"
                  v-if="styleCpf!=''"
                  style="color:rgb(243 0 0);font-size: 12px;"
                >*Obrigatorio</label>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <label>Telefone Fixo</label>
                <the-mask
                  placeholder="Telefone Fixo"
                  class="form-control"
                  :mask="['(##) ####-####']"
                  v-model="cidadao.telefone"
                  :style="styleTelefone"
                />
                <label
                  class="control-label"
                  v-if="styleTelefone!=''"
                  style="color:rgb(243 0 0);font-size: 12px;"
                >*Obrigatorio</label>
              </div>

              <div class="col-md-6">
                <label>Telefone Celular</label>
                <the-mask
                  placeholder="Telefone Celular"
                  class="form-control"
                  :mask="['(##) #####-####']"
                  v-model="cidadao.celular"
                  :style="styleCelular"
                />
                <label
                  class="control-label"
                  v-if="styleCelular!=''"
                  style="color:rgb(243 0 0);font-size: 12px;"
                >*Obrigatorio</label>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-12">
                <label>CEP</label>
                <the-mask
                  class="form-control"
                  type="text"
                  placeholder="CEP"
                  v-model="cidadao.cep"
                  v-on:input="buscarCep()"
                  :mask="['#####-###']"
                  :style="styleCep"
                />
                <label
                  class="control-label"
                  v-if="styleCep!=''"
                  style="color:rgb(243 0 0);font-size: 12px;"
                >*Obrigatorio</label>
              </div>
            </div>

            <div class="row">
              <div class="col-md-10">
                <base-input
                  type="text"
                  id="rua"
                  name="rua"
                  label="Rua"
                  placeholder="Rua"
                  v-model="cidadao.rua"
                  maxlength="150"
                ></base-input>
              </div>
              <div class="col-md-2">
                <base-input
                  type="number"
                  id="numero"
                  name="numero"
                  label="Número"
                  placeholder="Número"
                  v-model="cidadao.numero"
                  maxlength="150"
                ></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-9">
                <base-input
                  type="text"
                  id="bairro"
                  name="bairro"
                  label="Bairro"
                  placeholder="Bairro"
                  v-model="cidadao.bairro"
                  maxlength="150"
                ></base-input>
              </div>
              <div class="col-md-3">
                <base-input
                  type="text"
                  id="complemento"
                  name="complemento"
                  label="Complemento"
                  placeholder="Complemento"
                  v-model="cidadao.complemento"
                  maxlength="150"
                ></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-10">
                <label>Cidade</label>
                <input
                  type="text"
                  id="cidade"
                  name="cidade"
                  placeholder="Cidade"
                  v-model="cidadao.cidade"
                  maxlength="150"
                  class="form-control"
                  :style="styleCidade"
                />
                <label
                  class="control-label"
                  v-if="styleCidade!=''"
                  style="color:rgb(243 0 0);font-size: 12px;"
                >*Obrigatorio</label>

              </div>
              <div class="col-md-2">
                <label>Estado</label>
                <input
                  type="text"
                  id="estado"
                  name="estado"
                  placeholder="Estado"
                  v-model="cidadao.estado"
                  maxlength="150"
                  class="form-control"
                  :style="styleEstado"
                />
                <label
                  class="control-label"
                  v-if="styleEstado!=''"
                  style="color:rgb(243 0 0);font-size: 12px;"
                >*Obrigatorio</label>
              </div>
            </div>
            <div class="text-center">
              <button
                type="submit"
                class="btn btn-primary btn-fill float-left"
                @click.prevent="cidadaoRegistrar"
              >Cadastrar</button>
            </div>
            <div class="clearfix"></div>
          </form>
        </card>
      </div>
    </div>  
  </section>  
</template>
<script>

import Reload from 'src/components/Reload-v1.vue'
import Card from "src/components/Cards/Card.vue";
import axios from "axios";
import "src/controller/site/cidadaoController.js";
import { TheMask } from "vue-the-mask";

export default {
  name: 'Registo',
  metaInfo: {
    htmlAttrs: {
      lang: 'pt-BR',
    },
    title: 'Registar Cidadão',
    meta: [
      { name: 'descrition', content: 'Registrar Cidadão na Ouvidoria da Prefeitura Municipal de São José de Ubá.' },
      {property: 'og:title', content: 'Registar Cidadão'},
      {property: 'og:image', content: '/img/logo-topo.png'},
    ],
  },
  components: {
    Card,
    TheMask,
    Reload,
  },
  data() {
    return {
      reload_hab:false,
      registro: null,
      mask: "00)00000-0000",
      maskcpf: "000.000.000-00",
      cidadao: {
        nome: null,
        email: null,
        emailVerificar: null,
        senha: null,
        senhaVerificar: null,
        tipo: "Física",
        cpf: null,
        cnpj: null,
        telefone: null,
        celular: null,
        cep:null,
        rua: null,
        numero: null,
        bairro: null,
        cidade:null,
        complemento: null,
        estado:null,
      },
      dados_recebidos: [],
      styleNome: "",
      styleEmail: "",
      styleEmailVerify: "",
      EmailVerify: "",
      styleSenha: "",
      styleSenhaVerify: "",
      SenhaVerify: "",
      styleCpf: "",
      styleCnpj: "",
      styleTelefone: "",
      styleCelular: "",
      styleCep: "",
      styleCidade: "",
      styleEstado: "",
      emailverify: 0,
      senhaverify: 0,
      msgAlterada: null,
      msg: null,
      verify_email: false,
      verify_senha: false,
    };
  },

  methods: {
    limparAlertas(){
       //reseta os alertas
        this.msgAlterada = null;
        this.msg = null;
        this.styleNome = "";
        this.styleEmail = "";
        this.styleSenha = "";
        this.styleCpf = "";
        this.styleCnpj = "";
        this.styleTelefone = "";
        this.styleCep = "";
        this.styleCidade ="";
        this.styleEstado = "";
        this.styleCelular = "";
    },
    validacaoEmailVerify(email,emailVerificar){
      if(emailVerificar){
         if(email == emailVerificar){
            this.styleEmailVerify ="border: 2px solid rgb(64, 185, 124);";
            this.EmailVerify = 1;
            scroll(0, 100);
         }else{
            this.styleEmailVerify ="";
            this.EmailVerify = 0;
         }
      }
    },
    validacaoSenhaVerify(senha,senhaVerificar){
      if(senhaVerificar){
         if(senha == senhaVerificar){
            this.styleSenhaVerify ="border: 2px solid rgb(64, 185, 124);";
            this.SenhaVerify = 1;
            scroll(0, 100);
         }else{
            this.styleSenhaVerify ="";
            this.SenhaVerify = 0;
         }
      }
    },
    buscarCep: function (event) {

      //reseta os alertas antes de buscar o cep
      this.msgAlterada = "";
      this.styleCidade = "";
      this.styleEstado = "";

      //limpar campos de endereço
      this.cidadao.rua = "";
      this.cidadao.bairro = "";
      this.cidadao.cidade = "";
      this.cidadao.estado = "";

      var url_cep;

      //console.log(this.cidadao.cep);
                    
      if (event) {
         event.preventDefault();
      }
      
      if(this.cidadao.cep.length >7){
        url_cep = 'https://viacep.com.br/ws/' + this.cidadao.cep + '/json';

        // clear all headers axios to viacep
        axios.defaults.headers.common = null;

        axios.get(url_cep).then(function (response) {
          this.cidadao.rua = response.data.logradouro;
          this.cidadao.bairro = response.data.bairro;
          this.cidadao.cidade = response.data.localidade;
          this.cidadao.estado = response.data.uf;

          }.bind(this)).catch(function (error) {
            //console.log(error.statusText);
        }); 
      }        
    },
    validacaoEmail(email) {
      this.limparAlertas();
      if (email) {
        if (email.indexOf("@") >= 0) {
          if (email.indexOf(".") >= 0) {
            /*let separar = email.split("@");
                console.log(separar[0]); 
                console.log(separar[1]); */
            this.msgAlterada = "";
            this.styleEmail = "border: 2px solid rgb(64 185 124);";
            this.emailverify = 1;
            this.verify_email = true;
            return true;
          } else {
            //email.log("Não é um Email valido!")
            this.styleEmail = "border: 2px solid rgb(243 0 0);";
            this.msgAlterada = "Não é um Email valido!";
            this.emailverify = 0;
            this.verify_email = false;
            this.msg = 0;
            scroll(0, 100);
            return false;
          }
        } else {
          //email.log("Não é um Email valido!")
          this.styleEmail = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "Não é um Email valido!";
          this.emailverify = 0;
          this.verify_email = false;
          scroll(0, 100);
          this.msg = 0;
          return false;
        }
      } else {
        this.styleEmail = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Email está Vazio!";
        this.emailverify = 0;
        this.verify_email = false;
        this.msg = 0;
        scroll(0, 100);
        return false;
      }
    },
    validacaoSenha(senha) {
      this.limparAlertas();
      if (senha) {
        this.styleSenha = "";
        this.msgAlterada = "";
        this.senhaverify = 0;

        if (senha.length <= 3) {
          this.msgAlterada =
            "O campo Senha tem que ter no minimo 4 Caracteres!";
          this.msg = 0;
          this.senhaverify = 1;
          this.verify_senha = false;
          scroll(0, 100);
          return false;
        } else {
          this.msgAlterada = "";
        }

        if (senha.search(/[a-z]/i) < 0) {
          this.msgAlterada = "O campo Senha deve possuir no minimo uma letra!";
          this.msg = 0;
          this.senhaverify = 1;
          this.verify_senha = false;
          scroll(0, 100);
          return false;
        } else {
          this.msgAlterada = "";
        }

        if (senha.search(/[0-9]/i) < 0) {
          this.msgAlterada = "O campo Senha deve possuir no minimo um numero!";
          this.msg = 0;
          this.senhaverify = 1;
          this.verify_senha = false;
          scroll(0, 100);
          return false;
        } else {
          this.msgAlterada = "";
        }

        /*if (senha.search(/[!@#$%^&*]/i) < 0) {
          this.msgAlterada =
            "O campo Senha deve possuir no minimo um caracter especial!";
          this.msg = 0;
          this.senhaverify = 1;
          this.verify_senha = false;
          scroll(0, 100);
          return false;
        } else {
          this.msgAlterada = "";
        }*/

        this.senhaverify = 0;
        this.verify_senha = true;
      } else {
        this.styleSenha = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Senha está Vazio!";
        this.msg = 0;
        this.senhaverify = 0;
        this.verify_senha = false;
        scroll(0, 100);
        return false;
      }
    },
    async cidadaoRegistrar() {
      try {
        //limpando campos desnecesarios e verificando campos vazios
        
        this.limparAlertas();

        if (this.cidadao.nome == null || this.cidadao.nome == "") {
          this.styleNome = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Nome está Vazio!";
          this.msg = 0;
          scroll(0, 100);
          return false;
        }
        if (this.cidadao.email == null || this.cidadao.email == "") {
          this.styleEmail = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Email está Vazio!";
          this.msg = 0;
          scroll(0, 100);
          return false;
        }
        
        if (this.cidadao.emailVerificar == null || this.cidadao.emailVerificar == "") {
          this.styleEmailVerify = "border: 2px solid rgb(243 0 0);";
          this.EmailVerify = 0;
          this.msgAlterada = "O campo Email não foi Verificado!";
          this.msg = 0;
          scroll(0, 100);
          return false;
        }

        if (this.cidadao.senha == null || this.cidadao.senha == "") {
          this.styleSenha = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Senha está Vazio!";
          this.msg = 0;
          scroll(0, 100);
          return false;
        }

        if (this.cidadao.senhaVerificar == null || this.cidadao.senhaVerificar == "") {
          this.styleSenhaVerify= "border: 2px solid rgb(243 0 0);";
          this.SenhaVerify = 0;
          this.msgAlterada = "O campo Senha não foi Verificado!";
          this.msg = 0;
          scroll(0, 100);
          return false;
        }

        /*if (this.cidadao.tipo == "Física") {
          this.cidadao.cnpj = null;
          if (this.cidadao.cpf == null || this.cidadao.cpf == "") {
            this.styleCpf = "border: 2px solid rgb(243 0 0);";
            this.msgAlterada = "O campo CPF está Vazio!";
            this.msg = 0;
            scroll(0, 100);
            return false;
          }
        }
        if (this.cidadao.tipo == "Jurídica") {
          this.cidadao.cpf = null;
          if (this.cidadao.cnpj == null || this.cidadao.cnpj == "") {
            this.styleCnpj = "border: 2px solid rgb(243 0 0);";
            this.msgAlterada = "O campo CNPJ está Vazio!";
            this.msg = 0;
            scroll(0, 100);
            return false;
          }
        }*/

        if (this.cidadao.telefone == null || this.cidadao.telefone == "") {
          this.styleTelefone = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Telefone Fixo está Vazio!";
          this.msg = 0;
          scroll(0, 100);
          return false;
        }

        if (this.cidadao.celular == null || this.cidadao.celular == "") {
          this.styleCelular = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Telefone Celular está Vazio!";
          this.msg = 0;
          scroll(0, 100);
          return false;
        }

        /*if (this.cidadao.cep == null || this.cidadao.cep == "") {
          this.styleCep = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo CEP está Vazio!";
          this.msg = 0;
          scroll(0, 100);
          return false;
        }
        
        if (this.cidadao.cidade == null || this.cidadao.cidade == "") {
          this.styleCidade = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Cidade está Vazio!";
          this.msg = 0;
          scroll(0, 100);
          return false;
        }

        if (this.cidadao.estado == null || this.cidadao.estado == "") {
          this.styleEstado = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Estado está Vazio!";
          this.msg = 0;
          scroll(0, 100);
          return false;
        }*/

        this.validacaoSenha(this.cidadao.senha);
        if (!this.verify_senha) {
          this.msgAlterada = this.msgAlterada;
          this.msg = 2;
          this.senhaverify = 1;
          this.verify_senha = false;
          scroll(0, 100);
          return false;
        } else {
          this.msgAlterada = "";
          this.senhaverify = 0;
          this.msg = 0;
          this.verify_senha = true;
        }

        if (this.verify_email) {

          this.reload_hab = true;
          
          let data = await this.$cidadaoRegistrar(this.cidadao);
          this.reload_hab = false;
          
          if (data.msg == "CPF já está em uso!") {
            this.msgAlterada = data.msg;
            this.msg = 0;
            this.styleCpf = "border: 2px solid rgb(243 0 0);";
            scroll(0, 100);
            return false;
          }
          if (data.msg == "CPF invalido!") {
            this.msgAlterada = data.msg;
            this.msg = 0;
            this.styleCpf = "border: 2px solid rgb(243 0 0);";
            scroll(0, 100);
            return false;
          }
          if (data.msg == "CNPJ invalido!") {
            this.msgAlterada = data.msg;
            this.msg = 0;
            scroll(0, 100);
            return false;
          }
          if (data.msg == "CNPJ já está em uso!") {
            this.msgAlterada = data.msg;
            this.msg = 0;
            scroll(0, 100);
            return false;
          }
          if (data.msg == "O campo Nome está vazio!") {
            this.msgAlterada = data.msg;
            this.msg = 0;
            scroll(0, 100);
            return false;
          }
          if (data.msg == "O campo Email está vazio!") {
            this.msgAlterada = data.msg;
            this.msg = 0;
            scroll(0, 100);
            return false;
          }
          if (data.msg == "Email já está em uso!") {
            this.msgAlterada = "Email já está em uso!";
            this.msg = 0;
            scroll(0, 100);
            return false;
          }
          if (data.msg == "Informe a Senha!") {
            this.msgAlterada = data.msg;
            this.msg = 0;
            scroll(0, 100);
            return false;
          }
          if (data.msg == "Problemas na validacão!") {
            if(data.messages.telefone){
              this.msgAlterada = "O campo telefone é Obrigatorio!";
            }else{
              this.msgAlterada = data.msg;
            }
            scroll(0, 100);
            this.msg = 0;
            return false;
          }
          this.$router.push({
            name: "registromostrar",
            params: { dados_recebidos: this.cidadao },
          });
        } else {
          this.styleEmail = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "Não é um Email valido!";
          this.emailverify = 0;
          this.msg = 0;
          scroll(0, 100);
          return false;
        }
      } catch (e) {
        //console.log(e.message);
      }
    },
  },
  beforeMount() {},
};
</script>
<style>
ol {
  list-style: none;
}
.bread {
  padding-right: 0px;
  padding-left: 0px;
}
.bread-crumb {
  width: 100%;
  float: left;
  margin: 0px 0px 20px 0;
  position: relative;
  display: block;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}
.breadcrumb-fill0 {
  padding: 10px;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 0 40px -10px rgba(0, 0, 0, 0.25);
}
.bread-crumb li {
  height: auto;
  line-height: 30px;
  float: left;
  padding: 0 12px;
}
.bread-text,
.bread-text:hover {
  color: black;
}

.input-group-text-green {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
    padding: 0.375rem 0.75rem;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #ffffff;
    text-align: center;
    white-space: nowrap;
    background-color: #40b97c;
    border: 1px solid #40b97c;
    border-radius: 0.25rem;
    border-top-right-radius: 0rem;
    border-bottom-right-radius: 0rem;
}

.input-group .form-control:last-child, .input-group-addon:last-child, .input-group-btn:last-child > .dropdown-toggle, .input-group-btn:first-child > .btn:not(:first-child) {
    border: 1px solid #E3E3E3;
}

.input-group .form-control:first-child, .input-group-addon:first-child, .input-group-btn:first-child > .dropdown-toggle, .input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
   border: 1px solid #E3E3E3;
}
</style>
